/*
 * @Descripttion:
 * @Author: etong
 * @Date: 2022-04-22 15:11:38
 * @LastEditors: WangQi
 * @LastEditTime: 2022-07-25 10:30:36
 */
const map = {
  adProjectList: () => import('@/views/advertising/AdProjectList'), // 广告项目列表
  adProjectModuleDetail: () => import('@/views/advertising/components/AdProjectModuleDetail'), // 广告项目详情
  advertisingDetail: () => import('@/views/advertising/components/AdvertisingDetail'), // 广告详情
  advertisingList: () => import('@/views/advertising/AdvertisingList'), // 广告列表
  advertisingDetailList: () => import('@/views/advertising/AdvertisingDetailList'), // 广告明细列表
  createAdPublish: () => import('@/views/advertising/components/AdPublishDetail'), // 新建红人广告发布
  adPublishDetail: () => import('@/views/advertising/components/AdPublishDetail'), // 红人广告发布详情
  adPublishList: () => import('@/views/advertising/AdPublishList'), // 红人广告发布列表
  adAcceptanceDetail: () => import('@/views/advertising/components/AdAcceptanceDetail'), // 红人广告验收详情
  adAcceptanceList: () => import('@/views/advertising/AdAcceptanceList'), // 红人广告验收列表
  adCustomPaymentRecordDetail: () => import('@/views/advertising/components/AdCustomPaymentRecordDetail'), // 广告收款认领详情
  adCustomPaymentRecordList: () => import('@/views/advertising/AdCustomPaymentRecordList'), // 广告收款认领列表
  adSettlementList: () => import('@/views/advertising/AdSettlementList'), // 广告结算单
  adSettlementDetail: () => import('@/views/advertising/components/AdSettlementDetail'), // 广告结算单详情
  advertisingInvoiceDetail: () => import('@/views/advertising/components/AdvertisingInvoiceDetail'), // 红人广告发票详情
  adSettlementHrInvoiceModule: () => import('@/views/advertising/AdSettlementHrInvoiceModule'), // 广告发票列表
  createAdvertisingInvoice: () => import('@/views/advertising/components/AdvertisingInvoiceDetail') // 新建红人广告发票

}

export default map
